<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="a__Toc448782307"><span>Dedication</span></p>
<p class="P_WFP_BodyText">To my nephew, Griffin Melson, who graduates from high school the same week this book comes out. Now is a time of many decision points for you. Please know that whatever paths you take, I’ll be proud of you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?bfa3a650